import React, { useContext } from "react"

import { PriceContext } from "../../PriceContext"
import { TariffKey } from "./types"

import * as styles from "./badges.module.scss"

interface BadgesProps {
  tariff: TariffKey
  isFixed?: boolean
}

const Badges: React.FC<BadgesProps> = ({ tariff, isFixed = false }) => {
  const { addonsCount } = useContext(PriceContext)

  const raw =
    tariff === "Core"
      ? addonsCount.core
      : tariff === "Support"
        ? addonsCount.support
        : tariff === "Marketing"
          ? addonsCount.marketing
          : tariff === "MarketingExpert"
            ? addonsCount.marketingExpert
            : tariff === "EnterpriseMarketing"
              ? addonsCount.enterpriseMarketing
              : tariff === "EnterpriseSupport"
                ? addonsCount.enterpriseSupport
                : 0

  const count = Math.max(0, Math.trunc(Number(raw) || 0))

  if (count <= 0) return null

  const suffix =
    count % 10 === 1 && count % 100 !== 11 ? " модуль" : [2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100) ? " модуля" : " модулей"

  return (
    <div className={isFixed ? styles.badge : styles.badgesFixedWrapper}>
      + {count}
      {!isFixed && suffix}
    </div>
  )
}

export default Badges
